import { j as r } from "../../../jsx-runtime-c20f6c15.mjs";
import a from "clsx";
import e from "../../../shared/icons/chevron-down-fill.svg.mjs";
import "react";
const c = "_container_14q30_1", s = "_rotate180_14q30_11", i = "_rotate0_14q30_16", t = {
  container: c,
  rotate180: s,
  rotate0: i
};
function p({
  className: n,
  isOpen: o = !1
}) {
  return /* @__PURE__ */ r(
    "span",
    {
      className: a(
        t.container,
        {
          [t.rotate180]: o,
          [t.rotate0]: !o
        },
        n
      ),
      children: /* @__PURE__ */ r(e, {})
    }
  );
}
export {
  p as default
};
